import SignaturePad from "signature_pad";

export const SignatureHook = {
  signaturePad: undefined,

  mounted() {
    this.signaturePad = this.buildSignaturePad(this.el);
    const input = this.el.querySelector(":scope input");

    this.el.addEventListener("storybook:clear-signature", (_event) => {
      this.signaturePad.clear();

      if (input) {
        input.value = "";
        input.dispatchEvent(new Event("input", { bubbles: true }));
      }
    });
  },

  buildSignaturePad(el) {
    const canvas = el.querySelector(":scope canvas");
    const input = el.querySelector(":scope input");

    if (canvas) {
      const signaturePad = new SignaturePad(canvas, {
        backgroundColor: el.dataset.backgroundColor,
        minWidth: el.dataset.minPenWidth,
        maxWidth: el.dataset.maxPenWidth,
        penColor: el.dataset.penColor,
      });

      if (el.dataset.url) {
        const ratio = Math.max(window.devicePixelRatio ?? 1, 1);
        const width = canvas.offsetWidth;
        const height = canvas.offsetHeight;
        signaturePad.fromDataURL(el.dataset.url, { ratio, width, height });
      }

      // This is required to prevent weird drawing offset issue
      // due to custom canvas size (w-full / h-32)
      // Looping until canvas is visible (ie. shown in current form page)
      const canvasResizeHandler = () => {
        if (canvas.offsetWidth === 0 || canvas.offsetHeight === 0) {
          setTimeout(canvasResizeHandler, 500);
        } else {
          const ctx = canvas.getContext("2d");
          const ratio = Math.max(window.devicePixelRatio ?? 1, 1);
          canvas.width = canvas.offsetWidth * ratio;
          canvas.height = canvas.offsetHeight * ratio;
          ctx.scale(ratio, ratio);
          signaturePad.clear();
        }
      };

      canvasResizeHandler();

      if (input) {
        signaturePad.addEventListener("endStroke", () => {
          const dataURL = signaturePad.toDataURL("image/jpeg");
          input.value = dataURL;
          input.dispatchEvent(new Event("input", { bubbles: true }));
        });
      }
      return signaturePad;
    }
  },
};
